import React from "react";

function About() {
  return (
    <div className="container mt-5">

      {/* PAGE TITLE */}
      <div className="text-center mb-5">
        <h2 className="fw-bold">About Rithan Promoters</h2>
        <p className="text-muted w-75 mx-auto">
          Rithan Promoters specializes in developing and delivering quality
          residential and commercial projects with a strong focus on trust,
          transparency, and customer satisfaction.
        </p>
      </div>

      {/* MISSION VISION VALUES */}
      <div className="row text-center">

        <div className="col-md-4 mb-4">
          <div className="card shadow-sm h-100 p-4 border-0">
            <h1>🏗️</h1>
            <h5 className="fw-semibold mt-3">Our Mission</h5>
            <p className="text-muted">
              To deliver durable, modern and affordable constructions that
              provide long-term value and comfort for customers.
            </p>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="card shadow-sm h-100 p-4 border-0">
            <h1>🌍</h1>
            <h5 className="fw-semibold mt-3">Our Vision</h5>
            <p className="text-muted">
              To become a trusted real estate brand known for building
              sustainable communities and lasting relationships.
            </p>
          </div>
        </div>

        <div className="col-md-4 mb-4">
          <div className="card shadow-sm h-100 p-4 border-0">
            <h1>🤝</h1>
            <h5 className="fw-semibold mt-3">Our Values</h5>
            <p className="text-muted">
              Integrity, transparency, quality craftsmanship and customer
              commitment in every project we undertake.
            </p>
          </div>
        </div>

      </div>

      {/* STATS SECTION */}
      <div className="row text-center mt-5 bg-light p-4 rounded shadow-sm">

        <div className="col-md-3">
          <h2 className="fw-bold text-primary">50+</h2>
          <p className="text-muted">Projects Completed</p>
        </div>

        <div className="col-md-3">
          <h2 className="fw-bold text-primary">120+</h2>
          <p className="text-muted">Happy Clients</p>
        </div>

        <div className="col-md-3">
          <h2 className="fw-bold text-primary">10+</h2>
          <p className="text-muted">Years Experience</p>
        </div>

        <div className="col-md-3">
          <h2 className="fw-bold text-primary">24/7</h2>
          <p className="text-muted">Support</p>
        </div>

      </div>

    </div>
  );
}

export default About;
